import { render } from "./CrossStep2InCorso.vue?vue&type=template&id=2126760e"
import script from "./CrossStep2InCorso.vue?vue&type=script&lang=js"
export * from "./CrossStep2InCorso.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__